<div id="wrapper">
    <div id="menu-wrapper">
        <div id="menu" class="container">
            <ul>
                <li><a routerLink="/home">Home</a></li>
                <li><a routerLink="/kunst">Kunst & Cultuur</a></li>
                <li><a routerLink="/zorg">Zorg</a></li>
                <li><a routerLink="/cultuur">Onderwijs</a></li>
                <li><a routerLink="/contact">Contact</a></li>
            </ul>
        </div>
    </div>
    <div id="page" class="container">
      <div id="content">
        <h1>ALGEMENE VOORWAARDEN AUXILIUM CU(LTU)RA</h1>

        <p>
          <b>Artikel 1 - Toepasselijkheid</b>
        </p>
        <ol>
          <li>
            Deze Algemene Voorwaarden zijn van toepassing op alle aanbiedingen, rechtshandelingen, opdrachten, transacties, overeenkomsten, alsmede op de uitvoering daarvan,
            en/of dienstverlening, waarbij Auxilium Cu(ltu)ra contractspartij is.
          </li>
          <li>
            Deze Algemene Voorwaarden hebben te alle tijden voorrang, zelfs indien anderszins voorrang bedongen is, tenzij voorafgaande aan de overeenkomst met Auxilium Cu(ltu)ra
            uitdrukkelijk schriftelijk is overeengekomen tussen Auxilium Cu(ltu)ra en een derde partij dat toepasselijkheid van deze algemene voorwaarden is uitgesloten of beperkt.
            Iedere verwijzing van een Opdrachtnemer naar eigen algemene voorwaarden wordt door Auxilium Cu(ltu)ra nadrukkelijk van de hand gewezen en derhalve is Auxilium
            Cu(ltu)ra niet gebonden aan deze mogelijke algemene voorwaarden van een Opdrachtnemer.
          </li>
          <li>
            Mondelinge toezeggingen van of afspraken met functionarissen van Auxilium Cu(ltu)ra zijn, voor zover deze afwijken van schriftelijke overeenkomsten en/of van deze
            algemene voorwaarden, slechts bindend wanneer deze afspraken schriftelijk bevestigd worden door een vertegenwoordigingsbevoegde functionaris van Auxilium Cu(ltu)ra.
          </li>
          <li>
            Nietigheid of niet toepasselijkheid van één of meer van deze algemene voorwaarden voorkomende bedingen of een deel van een beding, in algemene zin of in een specifiek
            geval, doet niets af aan de werking en geldigheid van de overige bedingen.
          </li>
          <li>Tenzij uitdrukkelijk anders schriftelijk overeengekomen gelden termijnen van uitvoering van de overeenkomsten, nimmer als fatale termijnen.</li>
        </ol>
        <p>
          <b>Artikel 2 - Definities</b>
        </p>
        <p>In deze algemene voorwaarden gelden de navolgende definities:</p>
        <oL>
          <li>Auxilium Cu(ltu)ra: de te Rijnsburg statutair gevestigde besloten vennootschap met beperkte aansprakelijkheid Auxilium Cu(ltu)ra B.V.</li>
          <li>
            Opdrachtnemer: iedere natuurlijke persoon of rechtspersoon die gebruikt maakt van Auxilium Cu(ltu)ra en op basis van een overeenkomst van opdracht of
            modelovereenkomst, diensten en/of werkzaamheden uitvoert of gaat uitvoeren ten behoeve van een Opdrachtgever;
          </li>
          <li>
            Opdrachtgever: iedere natuurlijke persoon of rechtspersoon, voor wie een Opdrachtnemer krachtens een overeenkomst van opdracht of een modelovereenkomst diensten
            en/of werkzaamheden verricht;
          </li>
          <li>
            Overeenkomst van Opdracht of Modelovereenkomst: de schriftelijke overeenkomst tussen Opdrachtnemer en Opdrachtgever conform een door Auxilium Cu(ltu)ra en/of de
            Belastingdienst goedgekeurd model, op grond waarvan Opdrachtnemer werkzaamheden verricht of gaat verrichten dan wel diensten verleent of gaat verlenen;
          </li>
          <li>
            Facturering: het verwerken van de betalingen door Opdrachtgever conform de Raamovereenkomst met Auxilium Cu(ltu)ra en eventuele nadere afspraken met
            Opdrachtnemer aan de Opdrachtnemer;
          </li>
          <li>
            Identificatie: de vaststelling van de identiteit van de Opdrachtnemer aan de hand van de wettelijk omschreven documenten zoals voortvloeit uit de Wet op de
            Identificatieplicht 1993 en eventueel de Vreemdelingenwet 2000.
          </li>
          <li>
            Schriftelijk bewijs: een digitale of schriftelijke gegevens- of informatiedrager waarvan eenvoudig en binnen redelijke termijn kennis genomen kan worden van de inhoud en
            welke kunnen dienen als rechtsgeldig en toegelaten bewijs conform het Wetboek van Burgerlijke Rechtsvordering.
          </li>
          <li>
            Overmacht: Elke van de wil van genoemde partij onafhankelijke omstandigheid - ook al was deze ten tijde van het tot stand komen van de overeenkomst reeds te voorzien -
            die nakoming van de overeenkomst blijvend of tijdelijk verhindert, met inbegrip van, voor zover daaronder niet reeds begrepen, technische storingen in de computer- en
            (internet en tele-)communicatieapparatuur, alsmede elke andere omstandigheid welke in het maatschappelijk verkeer als ‘overmacht’ wordt begrepen.
          </li>
          <li>
            Grove schuld: Van grove schuld is uitsluitend sprake indien de overeengekomen termijn van de uitvoering van de overeenkomst met meer dan 50% wordt overschreden,
            behoudens ingeval van overmacht en/of het niet verstrekken van benodigde informatie door de Opdrachtgever en/of het achterwege blijven van volledige betaling door
            Opdrachtgever, en de Opdrachtnemer Auxilium Cu(ltu)ra alsnog schriftelijk heeft gesommeerd tot nakoming van de overeenkomst en daarbij een redelijke termijn heeft
            gesteld om de overeenkomst alsnog uit te voeren, en Auxilium Cu(ltu)ra daarna dan alsnog in gebreke blijft.
          </li>
          <li>
            Raamovereenkomst: De overeenkomst tussen Auxilium Cu(ltu)ra, opdrachtnemer en opdrachtgever waarin de door Auxilium Cu(ltu)ra te verlenen diensten zijn
            overeengekomen, alsmede waarop deze algemene voorwaarden van toepassing zijn.
          </li>
        </oL>
        <p><b>Artikel 3 - Aanbod Auxilium Cu(ltu)ra</b></p>
        <ol>
          <li>
            Auxilium Cu(ltu)ra zal tegenover Opdrachtnemer pas definitief gebonden zijn na het verstrijken van een bedenktermijn van 24 uur, te rekenen vanaf het moment dat de
            Raamovereenkomst wederzijds ondertekend is en ook voor het overige aan alle vereisten voor het totstandkomen van een wederzijds bindende overeenkomst voldaan is. Zo
            lang de hierboven genoemde bedenktermijn nog niet is ingegaan en verstreken, kan Auxilium Cu(ltu)ra een door haar geuit(e) aanbod of aanvaarding, in welke vorm of langs
            welke weg ook gedaan, nog intrekken.
          </li>
          <li>
            Ieder door Auxilium Cu(ltu)ra gedane aanbod gericht tot een Opdrachtnemer, is louter en alleen van toepassing op deze Opdrachtnemer en vertrouwelijk. Dit aanbod mag,
            tenzij met schriftelijke en voorafgaande instemming van Auxilium Cu(ltu)ra, niet verveelvoudigd worden en/of op enige andere wijze aan derden beschikbaar worden gesteld
            of ter inzage worden gegeven.
          </li>
          <li>Auxilium Cu(ltu)ra zal nimmer gehouden zijn om diensten te verlenen buiten de gebruikelijke omstandigheden of buiten gebruikelijke werkdagen tussen 10:00 en 18:00 uur.</li>
        </ol>
        <p><b>Artikel 4 - Overeenkomst van Opdracht / Modelovereenkomst</b></p>
        <ol>
          <li>
            Opdrachtnemer verbindt zich om met diens Opdrachtgever een overeenkomst aan te gaan conform de door Auxilium Cu(ltu)ra beschikbaar gestelde modelovereenkomst,
            althans een door Auxilium Cu(ltu)ra goedgekeurde overeenkomst van opdracht (Modelovereenkomst). Indien van de inhoud van de Modelovereenkomst wordt afgeweken,
            kunnen Opdrachtnemer en diens Opdrachtgever er niet langer op vertrouwen dat Opdrachtnemer niet als werknemer voor de loonheffingen hoeft te worden beschouwd,
            noch kan aanspraak worden gemaakt op enige vrijwaring vanuit Auxilium Cu(ltu)ra. Afwijking van de in de Modelovereenkomst voorziene wijze waarop betalingen door
            Opdrachtgever zullen worden gedaan (namelijk: rechtstreeks en volledig aan Auxilium Cu(ltu)ra) zorgt er in ieder geval voor dat Opdrachtgever en Opdrachtnemer op fiscaal
            gebied geen vertrouwen meer aan de Modelovereenkomst kunnen ontlenen.
          </li>
          <li>
            Auxilium Cu(ltu)ra is te allen tijde gerechtigd om een verzoek om met haar een overeenkomst te sluiten, of een aan haar aangeboden opdracht tot facturering, te weigeren.
            De overeenkomst of opdracht tot facturering wordt in ieder geval geweigerd in de volgende omstandigheden:
            <ol type="a">
              <li>de Opdrachtnemer is jonger dan 18; en/of</li>
              <li>de vergoeding is lager dan 25,- Euro; en/of</li>
              <li>indien het vermoeden bestaat dat sprake zal zijn van een schijnconstructie (bijvoorbeeld: doorlening door de Opdrachtgever).</li>
            </ol>
          </li>
          <li>
            Onverminderd het in het vorige lid bepaalde is Auxilium Cu(ltu)ra jegens de Opdrachtnemer gerechtigd de uitvoering van een door haar aanvaarde overeenkomst c.q.
            geaccepteerde opdracht te beëindigen, dan wel op te schorten of (verdere) uitvoering te weigeren, indien Auxilium Cu(ltu)ra de Opdrachtnemer niet vóór aanvang van de
            werkzaamheden genoegzaam heeft kunnen identificeren conform artikel 2 lid 7 van deze Algemene Voorwaarden.
          </li>
          <li>
            De Opdrachtnemer heeft eerst recht op de door Auxilium Cu(ltu)ra aan Opdrachtnemer te leveren prestatie, indien en voor zover de Opdrachtgever zijn verplichtingen tot
            betaling aan Auxilium Cu(ltu)ra uit hoofde van de Modelovereenkomst volledig is nagekomen.
          </li>
          <li>
            Elke overeenkomst wordt door Auxilium Cu(ltu)ra aangegaan onder de opschortende voorwaarde dat Auxilium Cu(ltu)ra bevoegd is om de kredietwaardigheid van de
            Opdrachtgever van Opdrachtnemer na te gaan, zulks in verband met de correcte nakoming van de beoogde overeenkomst. Mocht Auxilium Cu(ltu)ra van mening zijn, zulks
            op redelijke gronden, dat de Opdrachtgever van Opdrachtnemer niet (voldoende) kredietwaardig is, dan heeft Auxilium Cu(ltu)ra te allen tijde het recht af te zien van het
            sluiten van een overeenkomst met de Opdrachtnemer. Indien hiervan sprake is, dan zal Auxilium Cu(ltu)ra de Opdrachtnemer hiervan onverwijld schriftelijk in kennis
            stellen. In verband met zijn kredietwaardigheid kan Opdrachtgever aan Auxilium Cu(ltu)ra een genoegzame zekerheidstelling verlenen, zodat de overeenkomst tussen
            Auxilium Cu(ltu)ra en Opdrachtnemer (alsnog) tot stand zou kunnen komen.
          </li>
          <li>
            Alle verstrekte opdrachten worden door Auxilium Cu(ltu)ra uitsluitend aanvaard en uitgevoerd op basis van een Overeenkomst van Opdracht / Modelovereenkomst
            tussen Opdrachtnemer en Auxilium Cu(ltu)ra als bedoeld in artikel 7:400 e.v. BW, met uitsluiting van de artikelen 7:404 en 7:407 lid 2 BW.
          </li>
        </ol>
        <p><b>Artikel 5 - Factureren aan Opdrachtgever</b></p>
        <ol>
          <li>
            Opdrachtnemer en diens Opdrachtgever zijn in de tussen hen gesloten Overeenkomst van Opdracht / Modelovereenkomst overeengekomen dat Auxilium Cu(ltu)ra de
            facturering van de door Opdrachtnemer aan Opdrachtgever in rekening te brengen vergoeding, namens en voor rekening van Opdrachtnemer zal verzorgen op basis van
            door de Opdrachtnemer verstrekte informatie.
          </li>
          <li>
            Ten behoeve van de facturering zal Auxilium Cu(ltu)ra uitgaan van de door Opdrachtnemer opgegeven uren en tijden zoals opgenomen in het digitale registratiesysteem.
            Ook eventuele bijzondere afspraken zoals kortingen, (schade-) vergoedingen en verrekeningen worden inbegrepen. Alleen accounts waarvan alle gevraagde gegevens ten
            aanzien van prijs, opdracht, Opdrachtgever en Opdrachtnemer volledig ingevuld zijn, worden in behandeling genomen.
          </li>
          <li>
            Auxilium Cu(ltu)ra zal de uren en tijden te goeder trouw en naar beste weten kunnen verwerken. Voor eventuele onjuistheden in de door Opdrachtnemer doorgegeven
            tijden en/of eventuele andere correcties achteraf, kunnen door Auxilium Cu(ltu)ra extra kosten voor verwerking in rekening worden gebracht aan Opdrachtnemer.
          </li>
          <li>Auxilium Cu(ltu)ra zal de factuur aan Opdrachtgever verzenden binnen twee werkdagen na ontvangst van alle benodigde informatie.</li>
          <li>
            Indien de Opdrachtgever zijn verplichting tot betaling van de vergoeding aan Auxilium Cu(ltu)ra volgend uit de Overeenkomst van Opdracht / Modelovereenkomst niet
            nakomt, is Auxilium Cu(ltu)ra bevoegd voor rekening en risico van de Opdrachtnemer incassomaatregelen te nemen. Deze incassomaatregelen zullen bestaan uit:
            <ol type=a>
              <li>het (indien nodig) maximaal drie keer schriftelijk aanmanen van de Opdrachtgever indien de betalingstermijn met meer dan 14 dagen is overschreden.</li>
              <li>
                in overleg met en voor rekening en risico van de Opdrachtnemer de vordering ter incasso aanbieden aan een door Auxilium Cu(ltu)ra aangewezen incasso- of
                deurwaarderskantoor.
              </li>
            </ol>
          </li>
        </ol>
        <p><b>Artikel 6 - Verwerken vergoeding</b></p>
        <ol>
          <li>
            Na ontvangst van de betaling van het totaal op de factuur verschuldigde bedrag zoals vermeld in artikel 5 zal dit ontvangen bedrag verminderd worden met de conform
            artikel 1 Raamovereenkomst afgesproken kosten en reserveringen. Het restantbedrag zal vervolgens binnen de gestelde betalingstermijn na ontvangst van het bedrag
            worden verwerkt, waarna betaling aan Opdrachtnemer van het factuurbedrag zal plaatsvinden. Hierbij wordt artikel 18 van deze Algemene Voorwaarden in acht genomen.
          </li>
          <li>
            De termijn, waarbinnen de uitvoering van 6.1. behoort te zijn verricht, vangt eerst aan zodra alle voor de uitvoering van de overeenkomst noodzakelijke gegevens en de
            bedongen betalingen door Auxilium Cu(ltu)ra ontvangen zijn.
          </li>
          <li>
            Indien tussentijdse wijzigingen in artikel 1 van de Raamovereenkomst worden aangebracht of de uitvoering daarvan wordt opgeschort, wordt de termijn waarbinnen de
            dienstverlening van Auxilium Cu(ltu)ra dient plaats te vinden, verlengd met een redelijke termijn in verband met de uit te voeren extra werkzaamheden.
          </li>
          <li>Indien de uitvoering van de Raamovereenkomst is opgeschort, is Auxilium Cu(ltu)ra niet gehouden tot enige dienstverlening aan Opdrachtnemer.</li>
          <li>
            Indien aan de zijde van Auxilium Cu(ltu)ra vertraging in haar dienstverlening, dan wel in de uitvoering van de overeenkomst, ontstaat ten gevolge van het niet voldoen door de
            Opdrachtnemer van enige uit de overeenkomst voortvloeiende verplichting en/of de Opdrachtnemer geen medewerking verleent met betrekking tot de uitvoering van de
            overeenkomst, dan wordt de termijn waarbinnen de dienstverlening van Auxilium Cu(ltu)ra dient plaats te vinden tenminste verlengd met de duur van deze vertraging.
          </li>
          <li>
            Behoudens grove schuld aan de zijde van Auxilium Cu(ltu)ra geeft overschrijding van de termijn van uitvoering van de overeenkomst/ opdracht, door welke oorzaak dan ook,
            de Opdrachtnemer geen recht op vergoeding van directe of indirecte schade of op vergoeding van welke kosten dan ook, noch op het al dan niet met rechterlijke machtiging
            verrichten of doen verrichten van werkzaamheden ter uitvoering van de overeenkomst.
          </li>
        </ol>
        <p><b>Artikel 7 - Overmacht</b></p>
        <ol>
          <li>
            In geval van overmacht bij een door Auxilium Cu(ltu)ra ingeschakelde (rechts)persoon en die zich jegens Auxilium Cu(ltu)ra op overmacht beroept, zal dit mede als een bij
            Auxilium Cu(ltu)ra zelf aanwezige overmacht situatie worden aangemerkt die jegens de Opdrachtnemer dan wel de Opdrachtgever toepassing vindt.
          </li>
          <li>
            Indien naar het oordeel van Auxilium Cu(ltu)ra de overmacht van tijdelijke aard zal zijn, heeft Auxilium Cu(ltu)ra het recht de uitvoering van de overeenkomst op te schorten,
            totdat de omstandigheid die de overmacht oplevert, zich niet meer voordoet.
          </li>
          <li>
            Is naar het oordeel van Auxilium Cu(ltu)ra de overmacht situatie van blijvende aard, dan kunnen partijen een regeling treffen over de ontbinding van de overeenkomst en
            de daaraan verbonden gevolgen.
          </li>
          <li>
            De partij die meent in overmacht te (komen) verkeren, dient de andere partij daarvan onmiddellijk schriftelijk in kennis te stellen.
          </li>
          <li>
            Auxilium Cu(ltu)ra is gerechtigd betaling te vorderen van de prestaties, die bij de uitvoering van de betreffende overeenkomst zijn verricht in de periode vóór het tijdstip dat
            van de overmacht veroorzakende omstandigheid is gebleken.
          </li>
          <li>
            Wanneer de uitvoering van een overeenkomst op grond van overmacht wordt opgeschort of ingeval van een overmacht situatie van blijvende aard Auxilium Cu(ltu)ra of de
            Opdrachtnemer de overeenkomst opzegt, is Auxilium Cu(ltu)ra niet aansprakelijk voor schade, in welke vorm en naar welke aard dan ook, van een Opdrachtnemer en/of
            diens Opdrachtgever, waaronder begrepen, maar niet beperkt tot, gevolgschade.
          </li>

        </ol>
        <p><b>Artikel 8 - Aansprakelijkheid</b></p>
        <ol>
          <li>
            Auxilium Cu(ltu)ra aanvaardt op geen enkele wijze verantwoordelijkheid en/of aansprakelijkheid voor schade, kosten en/of verliezen, uit welke hoofde dan ook, die door de
            Opdrachtnemer mocht worden of kunnen zijn veroorzaakt in relatie tot de Opdrachtgever en/of derden.
          </li>
          <li>
            Auxilium Cu(ltu)ra is niet aansprakelijk voor rechtshandelingen en/of feitelijke handelingen die de Opdrachtnemer en/of de Opdrachtgever zijn aangegaan met elkaar of met
            derden.
          </li>
          <li>
            Indien en voor zover Auxilium Cu(ltu)ra uit welke hoofde dan ook aansprakelijk mocht zijn tegenover Opdrachtnemer en/of Opdrachtgever, dan blijft die aansprakelijkheid
            resp. de schade te allen tijde beperkt tot het bedrag van maximaal het bedrag van de openstaande factu(u)r(en) die de Opdrachtnemer door Auxilium Cu(ltu)ra heeft laten
            factureren, dan wel het bedrag van de door Opdrachtnemer aan Auxilium Cu(ltu)ra betaalde fee voor haar dienstverlening.
          </li>
        </ol>
        <p><b>Artikel 9 - Reclames</b></p>
        <ol>
          <li>
            Eventuele reclames door Opdrachtnemer worden door Auxilium Cu(ltu)ra slechts in behandeling genomen indien zij haar rechtstreeks binnen vijf werkdagen na de betaling
            aan Opdrachtnemer conform artikel 6 van deze voorwaarden schriftelijk hebben bereikt, zulks onder nauwkeurige en gedocumenteerde opgave van de aard en de grond der
            klachten.
          </li>
          <li>Indien de Opdrachtnemer niet conform het vorige lid handelt, wordt de Opdrachtnemer geacht de geleverde prestatie, te hebben aanvaard en goedgekeurd.</li>
        </ol>
        <p><b>Artikel 10 - Betaling</b></p>
        <oL>
          <li>
            De facturen in opdracht van en namens Opdrachtnemer door Auxilium Cu(ltu)ra verzonden aan Opdrachtgever dienen binnen uiterlijk 14 dagen na de factuurdatum te
            worden voldaan op een door Auxilium Cu(ltu)ra aangewezen bank- of girorekening, zonder enige korting of verrekening, anders dan voor zover vooraf anders schriftelijk is
            overeengekomen tussen Opdrachtgever en Opdrachtnemer met kennisgeving aan Auxilium Cu(ltu)ra. De aangegeven valutadag op de bank-/giroafschriften van Auxilium
            Cu(ltu)ra is bepalend en wordt derhalve als dag van betaling aangemerkt.
          </li>
          <li>Tenzij uitdrukkelijk anders schriftelijk is overeengekomen vindt betaling plaats in Euro’s.</li>
          <li>
            Alle betalingen van Opdrachtgever strekken primair tot voldoening van door Auxilium Cu(ltu)ra gemaakte (invorderings-) kosten en vervolgens ter voldoening van de oudste
            openstaande facturen.
          </li>
          <li>
            Indien Opdrachtgever om welke reden dan ook de door Opdrachtnemer bedongen vergoeding voor diens werkzaamheden betaalt aan iemand anders dan Auxilium Cu(ltu)ra,
            dan heeft Opdrachtnemer terzake die betalingen geen enkele aanspraak (noch op inhouding en afdracht van enigerlei premie of heffing ten behoeve van Opdrachtnemer,
            noch op enige uitbetaling aan Opdrachtnemer zelf) tegenover Auxilium Cu(ltu)ra. Auxilium Cu(ltu)ra behoudt terzake vergoedingen die uit hoofde van de Overeenkomst van
            Opdracht / Modelovereenkomst eigenlijk aan Auxilium Cu(ltu)ra betaald hadden moeten worden, doch (al dan niet met instemming van Auxilium Cu(ltu)ra) aan iemand
            anders zijn betaald, tegenover Opdrachtnemer wel aanspraak op betaling van de in de Raamovereenkomst overeengekomen factureringsfee.
          </li>
          <li>
            Indien de Opdrachtgever in verzuim is met betrekking tot haar betalingsverplichtingen tegenover Auxilium Cu(ltu)ra zal, behoudens schriftelijk te maken andersluidende
            afspraken, de Opdrachtnemer de te leveren prestatie opschorten. Auxilium Cu(ltu)ra is niet tot het betalen van enige vergoeding aan Opdrachtnemer verplicht in verband
            met het opschorten van diens werkzaamheden.
          </li>
          <li>
            Indien Auxilium Cu(ltu)ra werkzaamheden heeft verricht op grond van de Raamovereenkomst en aldus een factuur heeft verstuurd aan Opdrachtgever, maar geen volledige
            betaling van die factuur ontvangt, heeft Auxilium Cu(ltu)ra het recht het bedrag, aan haar verschuldigd op grond van de door haar verleende diensten, alsmede de incasso-
            en andere kosten, schaden en renten terstond en zonder dat enige waarschuwing, ingebrekestelling of rechterlijke tussenkomst nodig is, te verrekenen met de wel door
            Auxilium Cu(ltu)ra ontvangen vergoeding(en) van Opdrachtgever, dan wel bij gebreke daarvan, op te eisen bij Opdrachtnemer.
          </li>
        </oL>
        <p><b>Artikel 11 - Rente en kosten</b></p>
        <ol>
          <li>
            Alle te maken gerechtelijke en buitengerechtelijke kosten voor incasso zullen in rekening worden gebracht aan de Opdrachtnemer en vervolgens waar mogelijk verhaald
            worden op de Opdrachtgever. De gerechtelijke kosten omvatten mede alle feitelijke kosten van rechts- en procesbijstand tijdens een gerechtelijke procedure gemaakt ook
            voor zover die het door de rechtsprekende instantie gehanteerde liquidatietarief te boven gaan. De buitengerechtelijke incassokosten worden geacht tenminste 15% te
            bedragen van de door Auxilium Cu(ltu)ra te innen hoofdsom plus vervallen rente , zulks met een minimum van € 150,= exclusief btw, tenzij Auxilium Cu(ltu)ra als Auxilium
            Cu(ltu)ra aantoont dat de werkelijke kosten hoger waren, kan zij die hogere kosten bij Opdrachtnemer in rekening brengen.
          </li>
          <li>
            Opdrachtnemer stemt er uitdrukkelijk mee in dat Auxilium Cu(ltu)ra alle noodzakelijke maatregelen treft om de incasso te kunnen uitvoeren, waaronder in ieder geval
            begrepen een verhaalsmogelijkhedenonderzoek door een derde en het opvragen van uittreksels uit de Gemeentelijke Basis Administratie en/of uit de registers van de
            Kamer van Koophandel betreffende de Opdrachtgever, dan wel haar bestuurders. De daarmee gemoeide kosten zullen door Auxilium Cu(ltu)ra aan Opdrachtgever in
            rekening worden gebracht.
          </li>
          <li>
            De invordering door Auxilium Cu(ltu)ra geschiedt ten behoeve van de Opdrachtnemer mede op grond van een eigen invorderingsrecht van Auxilium Cu(ltu)ra uit hoofde van
            gehanteerde Overeenkomst van Opdracht / Modelovereenkomst.
          </li>
        </ol>
        <p><b>Artikel 12 - Vergoeding, tarief en tariefwijzingen door gewijzigde afspraken</b></p>
        <ol>
          <li>
            Het voor de Opdrachtnemer voor de duur van de opdracht geldende vergoeding en uit te oefenen diensten/werkzaamheden worden zelfstandig door de Opdrachtnemer
            vastgesteld in onafhankelijk overleg tussen de Opdrachtnemer en de Opdrachtgever. De Opdrachtgever zal overeenkomstig deze afspraak omtrent de vergoeding worden
            gefactureerd door Auxilium Cu(ltu)ra op basis van de door de Opdrachtnemer verstrekte gegevens en digitale tijdsregistratie.
          </li>
          <li>
            Auxilium Cu(ltu)ra maakt de tarieven voor de door haar te verlenen dienstverlening ten tijde van aanvang van de Raamovereenkomst bekend door vermelding in de
            Raamovereenkomst. De tarieven kunnen, tenzij uitdrukkelijk anders is afgesproken tussen Opdrachtnemer en Auxilium Cu(ltu)ra, te allen tijde worden aangepast door en
            vanaf het moment van bekendmaking van nieuwe tarieven via de site van Auxilium Cu(ltu)ra. De nieuwe tarieven worden in dat geval geacht met onmiddellijke ingang of
            zoveel later als staat vermeld op de site in de plaats te treden van de in de Raamovereenkomst opgenomen tarieven. Indien de Opdrachtnemer tussentijds in overleg met
            de Opdrachtgever zijn vergoeding wijzigt, zal Auxilium Cu(ltu)ra het nieuwe bedrag van de vergoeding in haar administratie en betalingen doorvoeren. Als de wijziging niet
            tijdig voor verzending van de factuur aan Auxilium Cu(ltu)ra is doorgegeven en daardoor extra werkzaamheden nodig zijn, dan kan Auxilium Cu(ltu)ra hiervoor een bedrag
            van € 80,00 per uur exclusief BTW, aan de Opdrachtnemer in rekening brengen.
          </li>
        </ol>
        <p><b>Artikel 13 - Verbod van doorlenen</b></p>
        <ol>
          <li>De Opdrachtnemer dient de met Opdrachtgever overeengekomen werkzaamheden persoonlijk te verrichten.</li>
          <li>Het is Opdrachtnemer niet toegestaan om zijn werkzaamheden zoals afgesproken met de Opdrachtgever uit te voeren ten behoeve van anderen dan de Opdrachtgever zelf.</li>
        </ol>
        <p><b>Artikel 14 - Duur van de opdracht en beëindiging</b></p>
        <ol>
          <li>
            De duur van de opdracht op basis waarvan de Opdrachtnemer zijn diensten en/of werkzaamheden verricht, wordt zelfstandig bepaald door de Opdrachtnemer in overleg met
            de Opdrachtgever. De duur wordt gespecificeerd weergegeven in de Overeenkomst van Opdracht / Modelovereenkomst.
          </li>
          <li>
            Opdrachtnemer dient Auxilium Cu(ltu)ra er direct van op de hoogte te stellen indien en zodra de opdrachtovereenkomst tussen Opdrachtnemer en Opdrachtgever eindigt,
            ongeacht de wijze waarop de betreffende opdrachtovereenkomst eindigt.
          </li>
          <li>
            Indien de Opdrachtnemer afwijkt van de overeengekomen duur van de opdracht zonder hiervan Auxilium Cu(ltu)ra tijdig op de hoogte te stellen, is de Opdrachtnemer steeds
            volledig aansprakelijk voor de bij Auxilium Cu(ltu)ra ontstane schade. De Opdrachtnemer vrijwaart Auxilium Cu(ltu)ra voor de daardoor bij Auxilium Cu(ltu)ra ontstane
            betalingsverplichtingen tegenover derden. Auxilium Cu(ltu)ra is niet aansprakelijk voor de dientengevolge bij de Opdrachtnemer mogelijk ontstane schade.
          </li>
          <li>
            De Opdrachtnemer vrijwaart Auxilium Cu(ltu)ra voor alle betalingsverplichtingen die voor Auxilium Cu(ltu)ra jegens de Opdrachtgever resp. Opdrachtnemer, de
            Belastingdienst, UWV of welke derde dan ook, uit hoofde van de opdracht, de uitvoering daarvan - de eventuele tussentijdse beëindiging daar onder begrepen - alsmede uit
            hoofde het in acht nemen van wettelijke, publiekrechtelijke of contractuele regelingen en wat dies meer zij, mochten ontstaan.
          </li>
        </ol>
        <p><b>Artikel 15 - Dienstverlening door Auxilium Cu(ltu)ra</b></p>
        <p>De dienstverlening van Auxilium Cu(ltu)ra bestaat uit:</p>
        <ol>
          <li>facturatie aan de Opdrachtgever overeenkomstig Artikel 5 van deze Algemene Voorwaarden;</li>
          <li>
            Na betaling van het volledige factuurbedrag door de Opdrachtgever aan Auxilium Cu(ltu)ra en indien voldaan is aan de identificatieverplichtingen door de Opdrachtnemer, het
            toepassen van reserveringen, kosten en premies, waarna een netto aan te merken bedrag resteert.
          </li>
        </ol>
        <p><b>Artikel 16 - Beperkingen</b></p>
        <ol>
          <li>Tussen Auxilium Cu(ltu)ra en de Opdrachtnemer is geen sprake van gezagsverhouding en derhalve ook nimmer sprake van privaatrechtelijke arbeidsovereenkomst.</li>
          <li>Auxilium Cu(ltu)ra onthoudt zich nadrukkelijk van de selectie en werving van zowel de Opdrachtnemer als van de Opdrachtgever.</li>
          <li>De Opdrachtnemer verricht de werkzaamheden voor Opdrachtgever onder eigen verantwoordelijkheid en voor eigen rekening en risico.</li>
          <li>Auxilium Cu(ltu)ra aanvaardt nimmer enige aansprakelijkheid voor de kwaliteit van de door de Opdrachtnemer geleverde prestatie(s).</li>
        </ol>
        <p><b>Artikel 17 - Arbeid en Vergoeding</b></p>
        <ol>
          <li>
            De Opdrachtnemer bepaalt zelfstandig en in onafhankelijk overleg met de Opdrachtgever de inhoud en de vergoeding van de opdracht en de werktijden van de te verrichten
            werkzaamheden.
          </li>
          <li>
            De Opdrachtnemer verplicht zich alle (rechten op) vergoedingen die hij/zij op de Opdrachtgever mocht verkrijgen op welke grond dan ook te laten betalen via Auxilium
            Cu(ltu)ra en deze nimmer rechtsreeks, zonder tussenkomst van Auxilium Cu(ltu)ra te zullen aanvaarden.
          </li>
        </ol>
        <p><b>Artikel 18 - Identificatie van de Opdrachtnemer</b></p>
        <ol>
          <li>
            De identificatie van de Opdrachtnemer geschiedt op de volgende, wettelijk voorgeschreven, wijze:
            <ol type=a>
              <li>
                een ingevuld en door de Opdrachtnemer ondertekend inschrijfformulier zoals dat door Auxilium Cu(ltu)ra beschikbaar wordt gesteld, waarop minimaal geval vermeld
                dienen te worden: achternaam en voorletters, adresgegevens, BSN/sofinummer, geboortedatum en –plaats, nationaliteit en bankrekeninggegevens;
              </li>
              <li>
                een kopie van een ten tijde van de aanvang van de Raamovereenkomst rechtsgeldig (= niet verlopen) identiteitsbewijs (paspoort of gemeentelijke identiteitskaart
                geen rijbewijs). Op het eerste verzoek van Auxilium Cu(ltu)ra dient een Opdrachtnemer het originele identiteitsbewijs ten kantore van Auxilium Cu(ltu)ra ter inzage
                te verstrekken.
              </li>
              <li>
                in het geval van personen die niet in het bezit zijn van de nationaliteit van één van de landen van de Europese Economische Ruimte of Kroatië : een kopie van een
                geldige werkvergunning of aantekening in het paspoort waarop is vermeld dat het verrichten van arbeid zonder bijzondere voorwaarden is toegestaan.
              </li>
              <li>
                De ingevulde en ondertekende Raamovereenkomst.
              </li>
            </ol>
          </li>
          <li>Opdrachtnemer verplicht zich om Auxilium Cu(ltu)ra onverwijld in kennis te stellen van enige wijziging in de gegevens zoals omschreven in lid 1 onder a.</li>
          <li>
            Auxilium Cu(ltu)ra behoudt zich het recht voor om de dienstverlening aan de Opdrachtnemer, zonder voorafgaande kennisgeving, op te schorten indien er een wijziging is
            opgetreden de gegevens van de Opdrachtnemer zoals bedoeld in lid 1 onder a en/of indien de documenten zoals bedoeld in lid 1 onder b en c niet meer geldig zijn.
          </li>
        </ol>
        <p><b>Artikel 19 - Privacy en gegevensbescherming</b></p>
        De door Auxilium Cu(ltu)ra verzamelde persoons- en bedrijfsgegevens dienen uitsluitend voor de correcte uitvoering van de door Auxilium Cu(ltu)ra aangegane overeenkomsten
        en ter uitvoering van de aan Auxilium Cu(ltu)ra als inhoudingsplichtige opgelegde wettelijke voorschriften. Behoudens een wettelijke verplichting daartoe zal Auxilium
        Cu(ltu)ra de in de voorgaande zin bedoelde gegevens op geen enkele wijze openbaar maken of verstrekken aan derden. Auxilium Cu(ltu)ra zal al hetgeen doen dat
        redelijkerwijs van haar verlangd kan worden om te voorkomen dat derden in het bezit komen van de aan Auxilium Cu(ltu)ra verstrekte gegevens.
        <p><b>Artikel 20 - Geschillen en Toepasselijk recht</b></p>
        <ol>
          <li>Alle geschillen tussen partijen zullen uitsluitend worden beslist door de competente Nederlandse gerechtelijke instantie van de vestigingsplaats van Auxilium Cu(ltu)ra.</li>
          <li>Op alle door Auxilium Cu(ltu)ra aangegane verbintenissen is bij uitsluiting Nederlands recht van toepassing.</li>
        </ol>

        <h1>Maatschappelijk Verantwoord Ondernemen (MVO)</h1>
        <p>
          Auxilium Cultura wil zich op een actieve en onderscheidende wijze binden aan het<br />
          maatschappelijk verantwoord ondernemen. Auxilium Cultura houdt zich continue<br />
          bezig met het balanceren aan milieu en sociaal gerelateerde en economische<br />
          vatbaarheid op het gebied van haar bedrijfsbeslissingen en -activiteiten. De drie P’s<br />
          zijn hierin dan ook de belangrijke leidraad om te zorgen dat er voldoende onderling<br />
          evenwicht is om aan de beoogde bedrijfsfilosofie optimaal te voldoen.<br />
        </p>

        <h4><span class="headline">1. Planet</span></h4>
        <p>
          <b>Milieu:</b><br />
          Auxilium Cultura heeft geen fysiek kantoor, er wordt gewerkt vanuit bestaande<br />
          locaties zonder gebruik te maken van extra energie, (fossiele) brandstoffen of enige<br />
          vorm van uitstoot.<br />
          Medewerkers werken voornamelijk van uit huis, gezamenlijke overleggen vinden<br />
          plaats op locaties die dezelfde uitgangspunten hanteren op het gebied van MVO<br />
          als Auxilium Cultura dat doet, hierbij valt te denken aan bestaande vergaderlocaties<br />
          en tijdelijk werkplekken.<br />
        </p>
        <p>
          Auxilium Cultura hanteert een “paperless” office; alle diensten en leveringen,<br />
          administraties, facturaties en overige schriftelijke zaken worden online gedaan.<br />
          Correspondentie wordt uitsluitend gevoerd via de e-mail en gespreken zullen zoveel<br />
          mogelijk digitaal gedaan worden. Het printen van documenten wordt in onze online<br />
          correspondentie ten zeerste afgeraden.<br />
          Hiermee zorgen wij ervoor dat het milieu zo weinig mogelijk belast wordt en er geen<br />
          afvalstroom ontstaat.<br />
        </p>

        <h4><span class="headline">2. People</span></h4>
        <p>
          <b>Medewerkers:</b><br />
          Auxilium Cultura houdt de overhead laag en maakt alleen gebruik van de<br />
          noodzakelijke voorzieningen om een gezonde bedrijfsvoering te kunnen hanteren.<br />
          Medewerkers zullen bedrijfsmiddel ter beschikking gesteld krijgen die voldoen aan<br />
          de juiste standaard als het gaat om verantwoord gebruik elektronische apparatuur.<br />
          Indien medewerkers dienen te reizen zal vanuit Auxilium Cultura gestimuleerd<br />
          worden om een zo laag mogelijke tot neutrale CO2 uitstoot te hebben; elektrisch<br />
          rijden, elektrisch fietsen en/of het gebruik van openbaar vervoer wordt hierbij<br />
          aangeraden.<br />
        </p>
        <p>
          <b>Opdrachtnemers:</b><br />
          Auxilium Cultura heeft te maken met veel verschillende contacten, zowel intern als<br />
          extern. De overgrote meerderheid van de contacten bestaat uit opdrachtnemers,<br />
          freelancer, ZZP-ers en ondernemers die hun financiële zaken door Auxilium Cultura<br />
          laten behartigen.<br />
          Aan opdrachtnemers zal hetzelfde gevraagd worden als bij bovenstaande om<br />
          aandacht te vragen om zich bewust te zijn van de impact op mens en milieu en om<br />
          een goede balans te zoeken tussen “planet, people and profit”.<br />
        </p>
        <p>
          <b>Opdrachtgevers:</b><br />
          Auxilium Cultura zal vele opdrachtgevers kennen, de bedrijven en instellingen waar<br />
          de opdrachtnemers hun werk zullen uitvoeren. Bij het actief werven van<br />
          opdrachtgevers zal immer gekeken worden naar hun beleid op het gebied van<br />
          MVO. Ook als opdrachtgevers de financiële administratie ten aanzien van hun<br />
          externe medewerkers willen outsourcen zal Auxilium Cultura kijken naar de mate van<br />
          MVO binnen deze ondernemingen en trachten hen mee te nemen in de<br />
          gedachtengoed die Auxilium Cultura voorstaat.<br />
        </p>

        <h4><span class="headline">3. Profit</span></h4>
        <p>
          <b>Goede doelen:</b><br />
          Auxilium Cultura streeft naar een goede bedrijfsvoering, het verzorgen van een juist<br />
          financieel netwerk en het maken van winst.<br />
          Juist de winst is een gegeven voor Auxilium Cultura om de bovengenoemde balans<br />
          te kunnen creëren. Het maatschappelijk verantwoord ondernemen van Auxilium<br />
          Cultura richt zich niet alleen op de eigen organisatie maar wil op een actieve wijze<br />
          iets terug door voor mens en milieu. De winst wordt voornamelijk gegenereerd door<br />
          de opdrachtgevers reeds met hun eigen MVO inzichten. Auxilium Cultura wil daar<br />
          graag nog een extra schep bovenop doen.<br />
        </p>
        <p>
          Aan de drie grootste opdrachtgevers zal jaarlijks gevraagd worden een goed doel<br />
          voor te stellen waar een donatie aan gedaan zal worden. Uit naam van Auxilium<br />
          Cultura en de opdrachtgever(s) zal een cheque worden uitgeschreven voor de<br />
          gekozen goede doelen tot een maximaal bedrag van 3% van de netto winst.<br />
        </p>
        <p>
          Goede doelen kunnen gekozen worden uit de “erkende goede doelen” via<br />
          <a href="url">www.goededoelen.nl</a>. Indien een bedrijf kiest voor een ander goed doel is dat<br />
            slechts mogelijk als die instelling een ANBI-status heeft.<br />
        </p>
        <p>
          Steeds na het verschijnen en deponeren van de jaarcijfers, de definitieve vaststelling<br />
          van de netto winst, zal de cheque of cheques aan de goede doelen worden<br />
          overhandigd in het bijzijn van betrokken partijen en uitgenodigde pers.<br />
        </p>
        <p>
          MVO beleid Auxilium Cultura 2020-2024<br />
          R. van Starkenburg<br />
          R. A. Moojen<br />
        </p>


      </div>
    </div>
</div>
